export const GET_CUSTOMER_DETAILS_REQUEST = 'GET_CUSTOMER_DETAILS_REQUEST';
export const GET_CUSTOMER_DETAILS_RESPONSE = 'GET_CUSTOMER_DETAILS_RESPONSE';

export const GET_REQUEST_STATUS = 'GET_REQUEST_STATUS';

export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_RESPONSE = 'GET_CUSTOMERS_RESPONSE';

export const BLOCK_OR_UNBLOCK_CUSTOMER = 'BLOCK_OR_UNBLOCK_CUSTOMER';



